// 此函数用于注册Service Worker
export function register() {
  // 只在生产环境和支持Service Worker的浏览器中注册
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // URL构造函数可用于解析URL
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    
    // 如果我们的应用程序是从不同的源提供的，则不注册Service Worker
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      // 注册Service Worker
      navigator.serviceWorker
        .register(swUrl)
        .then(registration => {
          console.log('Service Worker注册成功:', registration);
          
          // 检查更新
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // 此时已安装新的Service Worker
                  console.log('新内容可用，请刷新页面');
                } else {
                  // 此时尚未安装Service Worker
                  console.log('内容已缓存以供离线使用');
                }
              }
            };
          };
        })
        .catch(error => {
          console.error('Service Worker注册失败:', error);
        });
    });
  }
}

// 此函数用于注销Service Worker
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
} 